import React, { useState } from "react";
import Modal from "components/UI/DialogModal";
import {
  Button,
  CircularProgress,
  Grid,
  IconButton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Autocomplete,
} from "@mui/material";
import MuiButton from "components/UI/MuiButton";
import { useTranslation } from "react-i18next";
import DeleteIcon from "@mui/icons-material/Delete";
import { ITopic } from "models/topic";
import { ICompanyTopic, ICompanyTopicInput } from "models/companyTopics";
import { useAlert } from "contexts/alertContext";



interface Props {
  open: boolean;
  loading: boolean;
  topics: ITopic[];
  companyTopics: ICompanyTopic[];
  onClose: () => void;
  onSubmit: (data: ICompanyTopicInput[]) => void;
}





const AddCompanyTopic: React.FC<Props> = ({
  open,
  loading,
  topics,
  companyTopics,
  onClose,
  onSubmit,
}) => {
  const { t } = useTranslation();

  const [title, setTitle] = useState<string>("");
  const [titleAr, setTitleAr] = useState<string>("");
  const [entries, setEntries] = useState<ICompanyTopicInput[]>([]);
  const { setAlert } = useAlert();
  const topicsEnglishOptions = topics.map((topic) => ({
    value: topic.id,
    label: topic.name,
  }));

  const topicsArabicOptions = topics.map((topic) => ({
    value: topic.id,
    label: topic.nameAr,
  }));

  const handleTitleChange = (newValue: string | null) => {
    setTitle(newValue || "");

    const selectedTopic = topics.find((topic) => topic.name === newValue);
    if (selectedTopic) {
      setTitleAr(selectedTopic.nameAr);

    } else {
      setTitleAr("");

    }
  };

  const handleTitleArChange = (newValue: string | null) => {
    setTitleAr(newValue || "");

    const selectedTopic = topics.find((topic) => topic.nameAr === newValue);
    if (selectedTopic) {
      setTitle(selectedTopic.name);

    } else {
      setTitle("");
  
    }
  };

const combinationExisted = (topicAr: string, topicEn: string) => {

  const existingEntry = companyTopics?.find((entry) => entry?.name === topicEn && entry?.nameAr === topicAr);
  return existingEntry ? true : false;
}

  const addEntry = () => {
    if (title || titleAr) {
      const existingEntry = entries.some(
        (entry) => entry.name === title && entry.nameAr === titleAr
      );
      if ( 
        existingEntry ||
        combinationExisted(titleAr, title)
      ) {
        setAlert({
          open: true,
          message: "Topic Already Exists",
          type: "info",
        });
        return;
      }
      setEntries([
        ...entries,
        {
    
          name:  title,
          nameAr:  titleAr,
        },
      ]);
      setTitle("");
      setTitleAr("");
   
    }
  };

  const removeEntry = (index: number) => {
    setEntries(entries.filter((_, i) => i !== index));
  };


  const getNameFromId = (id: string | null, isArabic: boolean = false) => {
    const topic = topics.find((topic) => topic.id === id);
    return topic ? (isArabic ? topic.nameAr : topic.name) : "";
  };

  const clearFields = () => {
    setTitle("");
    setTitleAr("");
  
  };


  return (
    <>
      <Modal
        open={open}
        onClose={onClose}
        title={t("T_add_topic")}
        maxWidth="lg"
        children={
          <Stack spacing={2} p={2}>
            <div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "10px",
                }}
              >
                {/* <Autocomplete
                  freeSolo
                  options={topicsEnglishOptions.map((option) => option.label)}
                  style={{minWidth:'300px'}}
                  value={title}
           
                  onChange={(event, newValue) => handleTitleChange(newValue)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={t("T_title")}
                      variant="outlined"
                      onChange={(e) => setTitle(e.target.value)}
                   
                    />
                  )}
                /> */}

                    <TextField
                      value={title}
                      label={t("T_title")}
                      variant="outlined"
                      onChange={(e) => setTitle(e.target.value)}
                   
                    />
                {/* <Autocomplete
                  freeSolo
                  options={topicsArabicOptions.map((option) => option?.label || '')}
                  style={{minWidth:'300px'}}
                  value={titleAr}
               
                  onChange={(event, newValue) => handleTitleArChange(newValue)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={t("T_title_Ar")}
                      variant="outlined"
                      onChange={(e) => setTitleAr(e.target.value||'')}
                  
                    />
                  )}
                /> */}

                    <TextField
                      label={t("T_title_Ar")}
                      value={titleAr}
                      variant="outlined"
                      onChange={(e) => setTitleAr(e.target.value||'')}
                  
                    />
                <Button
                  variant="contained"
                  style={{ borderRadius: 0 }}
                  onClick={addEntry}
                  disabled={
                    !title 
                  }
                >
                  {t("T_add")}
                </Button>

                <Button
                  variant="outlined"
                  style={{ borderRadius: 0 }}
                  onClick={clearFields}
                >
                  {t("T_clear")}
                </Button>

              </div>

              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>{t("T_title")}</TableCell>
                    <TableCell>{t("T_title_Ar")}</TableCell>
                    <TableCell>{t("T_action")}</TableCell>
                  </TableRow>
                </TableHead>
              <TableBody>
                  {entries.map((entry, index) => (
                    <TableRow key={index}>
                      <TableCell>
                        {entry.name}
                      </TableCell>
                      <TableCell>
                         {entry.nameAr}
                      </TableCell>
                      <TableCell>
                        <IconButton onClick={() => removeEntry(index)}>
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
          </Stack>
        }
        actions={
          <Grid
            container
            alignItems={"center"}
            justifyContent={"space-between"}
            px={1}
          >
            <MuiButton
              variant="contained"
              sx={{ bgcolor: "warning.main", color: "white" }}
              size="large"
              onClick={onClose}
            >
              {t("T_cancel")}
            </MuiButton>
            <MuiButton
              variant="contained"
              sx={{ bgcolor: "primary.main", color: "white" }}
              disabled={loading}
              size="large"
              onClick={() => onSubmit(entries)}
            >
              {t("T_add")}
              <CircularProgress
                size={10}
                sx={{ mx: 2, display: loading ? "" : "none" }}
              />
            </MuiButton>
          </Grid>
        }
      />
    </>
  );
};

export default AddCompanyTopic;
